import type { Change } from '@gitbook/slate';

import { BLOCK_CODE_LINE } from '../types';

/**
 * Indent all lines in selection
 */
export function indentLines(
    change: Change,
    // Indent to add
    indent: string
): Change {
    const { value } = change;
    const { document, selection } = value;
    const lines = document
        .getBlocksAtRange(selection)
        .filter((node) => node.type === BLOCK_CODE_LINE);

    lines.forEach((line) => {
        // Insert an indent at start of line
        const text = line.nodes.first();
        // @ts-expect-error
        change.insertTextByKey(text.key, 0, indent);
    });

    return change;
}

/**
 * Dedent all lines in selection
 */
export function dedentLines(change: Change, indent: string): Change {
    const { value } = change;
    const { document, selection } = value;
    const lines = document
        .getBlocksAtRange(selection)
        .filter((node) => node.type === BLOCK_CODE_LINE);

    for (const line of lines) {
        const textNode = line.nodes.first();
        if (!textNode) {
            continue;
        }

        // Remove a level of indent from the start of line
        const lengthToRemove = firstDifferentCharacter(textNode.text, indent);
        change.removeTextByKey(textNode.key, 0, lengthToRemove);
    }

    return change;
}

// Return the index of the first character that differs between both string, or
// the smallest string length otherwise.
function firstDifferentCharacter(a: string, b: string): number {
    if (a.length > b.length) {
        return firstDifferentCharacter(b, a);
    }

    const indexes = Array(a.length)
        .fill(0)
        .map((_v, i) => i);
    const index = indexes.find((i) => a[i] !== b[i]);

    return index == null ? a.length : index;
}
